import React from "react";


function CardWithBody({children}) {
    return <div className="card">
        <div className="card-body">
            {children}
        </div>
    </div>
}

export default CardWithBody
